import { render } from "./DesignComponent.vue?vue&type=template&id=37736b80&scoped=true"
import script from "./DesignComponent.vue?vue&type=script&lang=js"
export * from "./DesignComponent.vue?vue&type=script&lang=js"

import "./DesignComponent.vue?vue&type=style&index=0&id=37736b80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37736b80"]])

export default __exports__